// eslint-disable-next-line func-style
export async function sha256(message) {
  const msgBuffer = new TextEncoder('utf-8').encode(message)
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => `00${b.toString(16)}`.slice(-2)).join('')
  return hashHex
}
